export default __webpack_public_path__ + "static/light-7134741ca60a2642b0ffaedf62de0fba.woff2";